// Slice 38 (ADR 0034) — Supabase client wrapper for the magic-link
// login flow. Only used when VITE_AUTH_MODE='supabase'; in the
// default 'dev' mode this file is tree-shaken out at build time
// (nothing imports it).
//
// The Supabase anon key is public by design — safe to ship in the
// bundle. Env vars both Vite-prefixed so they land in import.meta.env.

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

export type AuthMode = 'dev' | 'supabase';

export function getAuthMode(): AuthMode {
  const raw = import.meta.env['VITE_AUTH_MODE'];
  return raw === 'supabase' ? 'supabase' : 'dev';
}

let cached: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (cached) return cached;
  const url = import.meta.env['VITE_SUPABASE_URL'];
  const anonKey = import.meta.env['VITE_SUPABASE_ANON_KEY'];
  if (typeof url !== 'string' || url === '' || typeof anonKey !== 'string' || anonKey === '') {
    throw new Error(
      'Supabase mode requires VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in the admin build env',
    );
  }
  cached = createClient(url, anonKey, {
    auth: {
      // Magic-link flow lands on /auth/callback where we read the
      // session; no need for the client to detect it on page load.
      autoRefreshToken: true,
      persistSession: true,
      // Supabase defaults to sessionStorage when none configured;
      // explicit for clarity. Mirrors ADR 0021's dev-token storage.
      storage: globalThis.sessionStorage,
    },
  });
  return cached;
}
